import React, { useState, useEffect, useRef, useCallback } from 'react'
import { playableUrl } from '../../utils/playableUrl';
import { reloadIfLinksExpired } from '../../utils/expiredLinks';
import CardVideoPlayer from '../../components/CardVideoPlayer';
import BannerImg from "../../assets/images/banner.webp"
import { FiSearch } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineZoomOutMap } from "react-icons/md";
import MediaPreview from '../../components/MediaPreview';
import Loader from "../../assets/images/loader.gif"
import { useSelector, useDispatch } from "react-redux";
// import DatePicker from "react-datepicker";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import dayjs from "dayjs";
// import TextField from "@mui/material/TextField";


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import {
  setFileType,
  setSearchText,
  setOffsetTag,
  setPageSizeTag,
  setShowMoreTag,
  setOrientation,
  setSearchType,
  setLocationName,
  setEventName,
  setSelectMonthAndYear,
  setSelectYear,
  setTagNameFlag,
  resetSearch,
} from '../../redux/reducers/commonSlice';
import { setSelectedQuality, setCurrentPlaybackRate, setViewType, setVolume, setIsMuted } from '../../redux/reducers/commonSliceWhiteList';
function Banner(props) {
  const dispatch = useDispatch()
  const searchRef = useRef(null);
  const { fileType, searchText, locationName, eventName, searchType, selectMonthAndYear, selectYear, offsetTag, showMoreTag, tagList,
    pageSizeTag, loadingTag, tagNames, orientation, tagListIsFallback } = useSelector((state) => state.commonData)
  const { currentPlaybackRate, volume, isMuted } = useSelector((state) => state.commonDataWhiteList);
  const videoRefs = useRef({});
  const [hoveredBannerId, setHoveredBannerId] = useState(null);
  const [showInput, setShowInput] = useState(false)
  const [tagPopupFlag, setTagPopupFlag] = useState(false);
  const [sliceLength, setSliceLength] = useState(3);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const { userData } = useSelector((state) => state.masterData);
  const [value, setValue] = React.useState(null);
  const [openMonth, setOpenMonth] = useState(false);
  const [openYear, setOpenYear] = useState(false);
  const [isSearchBySegment, setIsSearchBySegment] = useState(false);
  const [tempValue, setTempValue] = useState(null);
  const [tempMonth, setTempMonth] = useState(null);
  const [tempYear, setTempYear] = useState(null);

  const [date, setDate] = useState(null);
  const [year, setYear] = useState(null); // initial null


  const isMobile = useCallback(() => {
    return window.innerWidth <= 768;
  }, []);

  const [isMobileDevice, setIsMobileDevice] = useState(isMobile());

  const handleClickOutside = useCallback((event) => {
    const bannerSearchDiv = document.querySelector(".banner-search-div");
    const bannerButtonWrapper = document.querySelector(".banner-button-wrapper");
    if (
      searchRef.current &&
      !searchRef.current.contains(event.target) &&
      bannerSearchDiv &&
      !bannerSearchDiv.contains(event.target) &&
      (!bannerButtonWrapper || !bannerButtonWrapper.contains(event.target))
    ) {
      props.setVideoListFlag?.(false);
    }
  }, []);

  useEffect(() => {
    //alert("111")
    setSelectMonthAndYear(dayjs())
    setSelectYear(dayjs())

    if (isMobileDevice) {
      setSliceLength(2);
    } else {
      setSliceLength(3);
    }

    const handleResize = () => {
      setIsMobileDevice(isMobile());
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileDevice, handleClickOutside]);

  useEffect(() => {
    //alert("222")
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        props.setVideoListFlag?.(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);



  // useEffect(() => {
  //    displayList = [...tagList];
  //   if (tagList.length <= 2) {
  //     displayList.push({ isViewAll: true, id: "view-all" });
  //   }
  // }, [tagList])
  const handleVolumeChange = (e) => {
    dispatch(setVolume(e.target.volume));
    dispatch(setIsMuted(e.target.muted));
  };


  const changeInput = useCallback(() => {
    setShowInput(prev => !prev);
    setIsSearchBySegment(prev => !prev)
  }, []);


  const handleDateChange = (selectedDate) => {
    setYear(null)
    setDate(selectedDate);
    dispatch(setSelectMonthAndYear(selectedDate));
    dispatch(setSelectYear(null));
    dispatch(setOffsetTag(0));
  };

  const handleYearChange = (selectedDate) => {
    // Ignore fake fallback date
 if (!selectedDate || isNaN(selectedDate.getTime())) return;
   setYear(selectedDate);
   setDate(null);
   // if (selectedDate) {
     //const selectedYear = selectedDate.getFullYear();
     dispatch(setSelectYear(selectedDate));
     dispatch(setSelectMonthAndYear(null));
     dispatch(setOffsetTag(0));
   // }
 };

 const handleYearClear = (e) => {
   if (e.target.value === "") {
     setYear(null);
     setDate(null);
 
     dispatch(setSelectYear(null));
     dispatch(setSelectMonthAndYear(null));
     dispatch(setOffsetTag(0));
   }
 };


  // The ONE way into View All. The card, Enter in any search box and a
  // "Did you mean" link all land on the same page, so they must all set the
  // same state: first page, View All page size, results page on, dropdown off.
  // (Enter and "Did you mean" used to leave the dropdown's page size of 10.)
  const openViewAll = useCallback(() => {
    dispatch(setOffsetTag(0));
    dispatch(setPageSizeTag(30));
    dispatch(setShowMoreTag(true));
    props.setVideoListFlag?.(false);
  }, [dispatch, props.setVideoListFlag]);

  const popupTagShow = useCallback((data) => {
    setSelectedData(data);
    setTagPopupFlag(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const cancelPopup = useCallback(() => {
    props.setVideoListFlag?.(false);
    dispatch(resetSearch());
    setDate(null);
    setYear(null);
    document.body.style.overflow = 'auto';
  }, [dispatch, props.setVideoListFlag]);

  const cancelTagPopup = useCallback(() => {
    setTagPopupFlag(false);
    document.body.style.overflow = 'auto';
  }, []);
  // const handleKeyDown = (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault(); // prevent form submit refresh
  //     // 👇 Redirect to view all page with search text (optional)
  //     navigate(`/view-all?search=${encodeURIComponent(searchText)}`);
  //   }
  // };
  const handleKeyDown = useCallback((e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // prevent form submit refresh
      openViewAll();
    }
  }, [openViewAll]);
  return (
    <div className='banner-wrapper'>
      <div className='banner-img-div'>
        <img
          className='img-fluid banner-img'
          src={BannerImg}
          alt='Banner image'
          width="100%"
          height={500}
        />
      </div>

      <div className='banner-search-wrapper'>
        <div className='container'>
          <h1 className='banner-head'>Unveil the Magic of Qatar</h1>

          <div className='banner-search'>
            <div className='banner-button-wrapper'>
              <button
                className={`banner-button ${fileType === "" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setFileType(""))
                  dispatch(setOffsetTag(0));
                }}
              >
                All
              </button>
              <button
                className={`banner-button ${fileType === "1" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setSearchType(null))
                  dispatch(setFileType("1"))
                  dispatch(setOffsetTag(0));
                }}
              >
                Images
              </button>
              <button
                className={`banner-button ${fileType === "2" ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setFileType("2"))
                  dispatch(setOffsetTag(0));
                }}
              >
                Videos
              </button>
            </div>

            <div className='col-12 col-md-9 tagNames banner-search-section'>
              <div className='banner-search-div main-search-div' >
                <div className={`position-relative banner-input-div banner-input-full ${showInput ? 'active' : ''}`}>
                  <FiSearch className='banner-search-input-icon' />
                  <input
                    type='text'
                    className='banner-search-input'
                    placeholder='Search'
                    value={searchText}
                    onChange={(e) => {
                      dispatch(setSearchText(e.target.value))
                      dispatch(setTagNameFlag(false));
                      dispatch(setOffsetTag(0));
                    }}
                    onKeyDown={handleKeyDown}
                  />
                </div>

                <div className={`banner-input-div banner-input-change ${showInput ? 'input-size-active' : ''}`}>
                  <input
                    type="text"
                    className='banner-search-input'
                    placeholder='Location'
                    value={locationName}
                    onChange={(e) => {
                      dispatch(setLocationName(e.target.value))
                      dispatch(setOffsetTag(0));
                    }}
                    onKeyDown={handleKeyDown}
                  />

                  {/* {fileType != "1" &&

                    <div className='checkbox-advance'>
                      <label className="custom-checkbox label-class-checkbox">
                        <input type="checkbox"
                          checked={searchType === 1}
                          onChange={(e) => {
                            dispatch(setSearchType(e.target.checked ? 1 : 0))
                            dispatch(setOffsetTag(0));
                          }} />
                        <span className="checkmark"></span>
                      </label>
                      <label className='advance-label'>Search by segment</label>
                    </div>

                  } */}
                </div>
                <div className={`banner-input-div banner-input-change ${showInput ? 'input-size-active' : ''}`}>

                  <input
                    type="text"
                    className='banner-search-input'
                    placeholder='Event'
                    value={eventName}
                    onChange={(e) => {
                      dispatch(setEventName(e.target.value))
                      dispatch(setOffsetTag(0));
                    }}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                {/* <div className={`banner-input-div banner-input-change ${showInput ? 'input-size-active-last' : ''}`}>
                  <DatePicker
                    selected={selectDate}
                    className='banner-search-input'
                    // placeholderText="Date"
                    // dateFormat="dd-MM-yyyy"
                     placeholderText="Month / Year"
                     dateFormat="MM/yyyy" 
                    onChange={(date) => {
                      dispatch(setSelectDate(date))
                      dispatch(setOffsetTag(0));
                    }}
                    isClearable
                    showMonthYearPicker
                    calendarClassName="custom-calendar"
                    renderCustomHeader={({
                      date,
                      decreaseMonth,
                      increaseMonth,
                      prevMonthButtonDisabled,
                      nextMonthButtonDisabled,
                    }) => (
                      <div className="custom-header">
                        <div className="custom-header-top">
                          <div className="day">
                            {date.toLocaleDateString("en-US", {
                              weekday: "short",
                              month: "short",
                              day: "numeric",
                            })}
                          </div>
                        </div>
                        <div className="custom-month-nav">

                          <span className="month-year">
                            {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
                          </span>
                          <div>
                            <span onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className="btn-picker">
                              <MdKeyboardArrowLeft color="#fff" size={25} />
                            </span>
                            <span onClick={increaseMonth} disabled={nextMonthButtonDisabled} className="btn-picker">
                              <MdOutlineKeyboardArrowRight color="#fff" size={25} />
                            </span>
                          </div>

                        </div>
                      </div>
                    )} />
                </div> */}


                <div className={`banner-input-div banner-input-change banner-style-line custom-date-picker ps-3 ${showInput ? "input-size-active-last" : ""}`}>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    views={["month", "year"]}
    value={selectMonthAndYear || null}
    onChange={(newValue) => {
      if (!newValue) return;
      setTempMonth(newValue.month()); // 0-based month
      setTempYear(newValue.year());
    }}
    onAccept={() => {
      if (tempMonth !== null && tempYear !== null) {
        const fixedDate = dayjs().year(tempYear).month(tempMonth);
        dispatch(setSelectMonthAndYear(fixedDate));
        dispatch(setSelectYear(null));
        dispatch(setOffsetTag(0));
      }
    }}
    format="MMM YYYY"
    open={openMonth}
    onOpen={() => { setOpenMonth(true); setOpenYear(false); }}
    onClose={() => setOpenMonth(false)}
    slotProps={{
      textField: {
        placeholder: selectMonthAndYear ? undefined : "Month/Year",
        variant: "standard",
        InputProps: { disableUnderline: true },
        sx: {
          "& .MuiInputBase-input": {
            color: "#fff",
            fontWeight: 600,
            fontSize: "14px",
            padding: "2px 4px",
            cursor: "pointer",
            width: "80px",
          },
          "& .MuiInputBase-input::placeholder": { color: "#fff", opacity: 0.7 },
        },
      },
    }}
    slots={{ openPickerIcon: () => null }}
  />
</LocalizationProvider> */}
                  <DatePicker
                    selected={date}
                    onChange={handleDateChange}
                    dateFormat="MMM yyyy"
                    showMonthYearPicker          // important for month/year picker
                    showYearDropdown             // important for year dropdown
                    scrollableYearDropdown        // allows scrolling through years
                    yearDropdownItemNumber={20}  // number of years in dropdown
                    placeholderText="Month/Year"
                  />

                </div>
                <div className={`banner-input-div banner-input-change change-border-style ps-3 border-default-div custom-date-picker ${showInput ? "input-size-active-last" : ""}`}>
                  <DatePicker
                    selected={year}
                    onChange={handleYearChange}
                    onChangeRaw={handleYearClear}
                    showYearPicker        // important: only year
                    dateFormat="yyyy"     // display only year
                    placeholderText="Year" // placeholder when null
                  />
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      // label="Month / Year"
                      views={["year"]} // 👈 Only month & year picker
                      value={selectYear ? selectYear : null}
                      onChange={(newValue) => {
                        dispatch(setSelectYear(newValue));
                        dispatch(setSelectMonthAndYear(null));
                        dispatch(setOffsetTag(0));
                      }}
                      format={selectYear ? "YYYY" : "Year"}// 👈 Displays Jan 2025 format
                      open={openYear}
                      onOpen={() => {
                        setOpenYear(true);
                        setOpenMonth(false); // ✅ close month picker if open
                      }}
                      onClose={() => setOpenYear(false)}
                      slotProps={{
                        textField: {
                          placeholder: "Year",
                          variant: "standard", // removes border
                          InputProps: {
                            disableUnderline: true, // no underline
                          },
                          sx: {
                            "& .MuiInputBase-input": {
                              color: "#fff",      // month/year text white
                              fontWeight: 600,
                              fontSize: "16px",
                              cursor: "pointer",
                            },
                            "& .MuiInputBase-input::placeholder": {
                              color: "#fff",
                              opacity: 0.7,
                            },
                          },
                          onClick: () => {
                            setOpenYear(true);
                            setOpenMonth(false); // ✅ prevent both opening
                          },
                          onKeyDown: (e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              dispatch(setOffsetTag(0));
                              dispatch(setShowMoreTag(true));
                              props.setVideoListFlag?.(false);
                            }
                          },
                        }
                      }
                      }
                      slots={{
                        openPickerIcon: () => null, // removes calendar icon
                        // calendarHeader: (slotProps) => (
                        //   <CustomHeader
                        //     currentMonth={slotProps.currentMonth}
                        //     onMonthChange={slotProps.onMonthChange}
                        //     minDate={slotProps.minDate}
                        //     maxDate={slotProps.maxDate}
                        //   />
                        // ),
                      }}
                    />
                  </LocalizationProvider> */}
                </div>
                {props.videoListFlag && (
                  <span className="closeBtn-search">
                    <IoCloseOutline size={32} onClick={cancelPopup} />
                  </span>
                )}

                <div className='advance-search-div checkbox-advance' >
                  {isSearchBySegment &&
                    <>
                      <div className={`d-flex align-items-center gap-1 me-3`}>
                        <label className="custom-checkbox label-class-checkbox">
                          <input type="checkbox"
                            checked={orientation === "Horizontal"}
                            onChange={(e) => {
                              dispatch(setOrientation(e.target.checked ? "Horizontal" : ""));
                              dispatch(setOffsetTag(0));
                            }}
                          />
                          <span className="checkmark"></span></label><label className="advance-label">Horizontal</label>

                      </div>
                      <div className={`d-flex align-items-center gap-1 me-3 `}>
                        <label className="custom-checkbox label-class-checkbox">
                          <input type="checkbox"
                            checked={orientation === "Vertical"}
                            onChange={(e) => {
                              dispatch(setOrientation(e.target.checked ? "Vertical" : ""));
                              dispatch(setOffsetTag(0));
                            }}
                          />
                          <span className="checkmark"></span></label><label className="advance-label">Vertical</label>

                      </div>
                      {fileType !== "1" &&
                        <div className={`d-flex align-items-center gap-1 me-3`}>
                          <label className="custom-checkbox label-class-checkbox">
                            <input type="checkbox"
                              checked={searchType === 1}
                              onChange={(e) => {
                                dispatch(setSearchType(e.target.checked ? 1 : 0))
                                dispatch(setOffsetTag(0));
                              }} />
                            <span className="checkmark"></span></label><label className="advance-label">Search by segment</label>

                        </div>}

                    </>
                  }
                  <span className="ms-1" onClick={changeInput}>Advanced Search</span>
                </div>

              </div>

              {props.videoListFlag && (
                <div className={`banner-search-list ${props.videoListFlag ? '' : 'd-none'}`} ref={searchRef}>
                  {(tagListIsFallback && tagList?.length > 0) && (
                    <div className='col-md-12'>
                      <p className='banner-search-text text-start mb-0'>No exact match for "{searchText}". Showing media that matches some of these words.</p>
                    </div>
                  )}
                  {tagNames.length > 0 && (
                    <div className='col-md-12'>
                      <p className='banner-search-text text-start mb-0'>
                        Did you mean:
                        {tagNames.map((name, i) => (
                          <span
                            className='f-medium banner-search-text-span'
                            key={i}
                            onClick={() => {
                              dispatch(setSearchText(name))
                              dispatch(setTagNameFlag(true));
                              openViewAll();
                            }}
                          >
                            {name}
                          </span>
                        ))}
                      </p>
                    </div>
                  )}

                  <div className="banner-search-sublist">
                    {tagList?.length > 0 ? (
                      <>
                        {tagList.slice(0, sliceLength).map((data, i) => (
                          <div className='col-md-4' key={data.id || i}>
                            <div
                              className="card"
                            // onMouseEnter={() => handleVideoMouseEnter(data)}
                            // onMouseLeave={() => handleVideoMouseLeave(data.id)}
                            >
                              {data.file_type_id === 2 ? (
                                <div
                                  onMouseEnter={() => setHoveredBannerId(data.video_id)}
                                  onMouseLeave={() => setHoveredBannerId(null)}
                                >
                                  <CardVideoPlayer
                                    ref={(el) => { videoRefs.current[data.video_id] = el; }}
                                    url={playableUrl(data, isFullScreen ? '1080' : '480')}
                                    poster={data?.thumbnail_image}
                                    playing={props.isAuthenticated && hoveredBannerId === data.video_id}
                                    controls
                                    muted
                                    playbackRate={currentPlaybackRate}
                                    volume={volume}
                                    className="banner-search-tag"
                                    onVolumeChange={handleVolumeChange}
                                    onPlay={() => { if (!props.isAuthenticated) { window.location.href = "/login"; } }}
                                    onContextMenu={(event) => event.preventDefault()}
                                  />
                                </div>
                              ) : (
                                <div className='img-outer position-relative image-container'>
                                  <img
                                    src={data.url}
                                    className="banner-search-tag media-no-save"
                                    draggable={false}
                                    alt="search result"
                                    width={100}
                                    height={100}
                                    onError={(e) => reloadIfLinksExpired(e.target.src)}
                                    onContextMenu={(event) => event.preventDefault()}
                                    onClick={() => popupTagShow(data)}
                                  />
                                  {sliceLength !== i + 1 && (
                                    <MdOutlineZoomOutMap
                                      className='img-zoom'
                                      onClick={() => popupTagShow(data)}
                                    />
                                  )}
                                </div>
                              )}

                              {sliceLength !== i + 1 ? (
                                <div className="card-body">
                                  <h5 className="card-title" title={data.video_heading}>
                                    {data.video_heading}
                                  </h5>
                                </div>
                              ) : (
                                (isMobileDevice ? sliceLength === 2

                                  : sliceLength === 3) && (
                                  <div className="card-body card-show-more" onClick={openViewAll}>
                                    <span className="card-title">View All</span>
                                  </div>
                                )
                              )}

                            </div>

                          </div>

                        ))}
                        {tagList.length <= 2 && (


                          <div className="col-md-4">
                            <div
                              className="card d-flex align-items-center justify-content-center"
                              onClick={openViewAll} style={{ height: "100%", cursor: "pointer", border: '1px solid #cccccc14,background:"#f7f7f7"' }}
                            >
                              <div className="">
                                View All
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      (!loadingTag) && (
                        <div className='col-md-4'>
                          <p>No data found</p>
                        </div>
                      )
                    )}

                    {loadingTag && (
                      <div className="d-flex flex-column text-center">
                        <div>
                          <img
                            src={Loader}
                            alt="Loading..."
                            className="img-fluid"
                            width="100"
                            height="100"
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='col-md-12 mt-0'>
                    <hr className='theme-color mt-0' />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <MediaPreview
        open={tagPopupFlag}
        url={selectedData.url}
        fileType={selectedData.file_type_id}
        qualityTypeArray={selectedData.qualityTypeArray}
        poster={selectedData.thumbnail_image}
        onClose={cancelTagPopup}
        onPlay={() => { if (!props.isAuthenticated) window.location.href = '/login'; }}
      />
    </div>
  );
}
function CustomHeader({ currentMonth, onMonthChange, minDate, maxDate }) {
  const prevDisabled = minDate && currentMonth.isBefore(minDate, "month");
  const nextDisabled = maxDate && currentMonth.isAfter(maxDate, "month");

  return (
    <div className="custom-header">
      <div className="custom-header-top">
        <div className="day">
          {currentMonth.format("ddd, MMM D")}
        </div>
      </div>

      <div className="custom-month-nav">
        <span className="month-year">
          {currentMonth.format("MMMM YYYY")}
        </span>

        <div>
          <span
            onClick={() => !prevDisabled && onMonthChange(currentMonth.subtract(1, "month"))}
            className={`btn-picker ${prevDisabled ? "disabled" : ""}`}
          >
            <MdKeyboardArrowLeft color="#fff" size={25} />
          </span>
          <span
            onClick={() => !nextDisabled && onMonthChange(currentMonth.add(1, "month"))}
            className={`btn-picker ${nextDisabled ? "disabled" : ""}`}
          >
            <MdOutlineKeyboardArrowRight color="#fff" size={25} />
          </span>
        </div>
      </div>
    </div>
  );
}


// export default Banner;
export default Banner;
